// ----------------------------------------------------------------------------
// Управляет показать или скрыть элемент
// ----------------------------------------------------------------------------



export const showHide = (el, show) => {
    if (show) {
        el.classList.replace('tt-animation-hide', 'tt-animation-show');
    } else {
        el.classList.replace('tt-animation-show', 'tt-animation-hide');
    }
}


export const hideElement = (el) => {
    if (el) {
        el.style.display = 'none';
    }
}


export const showElement = (el) => {
    if (el) {
        el.style.display = '';
    }
}